import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const projects = [
  {
    id: 1,
    title: 'Энергоснабжение завода металлоконструкций',
    description:
      'Поставка трансформаторов ТСЛ-1000/10/0,4 для обеспечения надежного энергоснабжения производственных линий.',
    location: 'г. Казань',
    image:
      'https://images.pexels.com/photos/1267338/pexels-photo-1267338.jpeg?auto=compress&cs=tinysrgb&w=800',
    link: '/projects/1',
  },
  {
    id: 2,
    title: 'Модернизация подстанции логистического центра',
    description:
      'Комплексная поставка КТПН-2×630/10/0,4 с трансформаторами ТСЗ для бесперебойного питания складского комплекса.',
    location: 'Московская область',
    image:
      'https://images.pexels.com/photos/2760241/pexels-photo-2760241.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    link: '/projects/2',
  },
  {
    id: 3,
    title: 'Энергообеспечение строительства ЖК',
    description:
      'Поставка комплекта КСО и трансформаторов ТСЗ для питания строительной площадки и последующей эксплуатации ЖК.',
    location: 'г. Санкт-Петербург',
    image:
      'https://images.pexels.com/photos/2138126/pexels-photo-2138126.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
    link: '/projects/3',
  },
];

const FeaturedProjects: React.FC = () => {
  return (
    <section className="py-16 md:py-24 bg-primary-50">
      <div className="container-custom">
        <div className="mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Наши проекты – от заводов до подстанций
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl">
            За годы работы мы успешно реализовали сотни проектов по поставке трансформаторного
            оборудования для различных объектов
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {projects.map((project) => (
            <Link
              key={project.id}
              to={project.link}
              className="card card-hover group bg-white"
              aria-label={`Подробнее о проекте: ${project.title}`}
            >
              <div className="h-48 overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                  width="341"
                  height="192"
                />
              </div>
              <div className="p-6">
                <div className="mb-2 text-sm font-medium text-primary-600">{project.location}</div>
                <h3 className="text-lg font-semibold mb-2 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {project.title}
                </h3>
                <p className="text-gray-600 mb-4 line-clamp-3">{project.description}</p>
                <div className="inline-flex items-center font-medium text-primary-600 group-hover:text-primary-700">
                  Подробнее
                  <ArrowRight
                    className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1"
                    aria-hidden="true"
                  />
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="mt-12 text-center">
          <Link to="/projects" className="btn-secondary" aria-label="Посмотреть все проекты">
            Все проекты
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProjects;
